
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

interface FooterQuickLinksProps {
  onNavigate: (hash: string) => void;
}

const FooterQuickLinks = ({ onNavigate }: FooterQuickLinksProps) => {
  const location = useLocation();
  const navigate = useNavigate();
  const isHomePage = location.pathname === '/';

  const handleClick = (e: React.MouseEvent, hash: string) => {
    e.preventDefault();
    
    if (isHomePage) {
      // We're already on the homepage, just scroll to the element
      onNavigate(hash);
    } else {
      // Navigate to the homepage first and then scroll
      navigate('/', { state: { noRedirect: true } });
      
      // Give the page time to load before scrolling
      setTimeout(() => {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  };

  return (
    <div>
      <h3 className="font-bold mb-4 text-lg">Quick Links</h3>
      <ul className="space-y-2">
        <li>
          <a 
            href="/#about"
            className="text-gray-300 hover:text-white transition-colors"
            onClick={(e) => handleClick(e, '#about')}
          >
            About NationCard
          </a>
        </li>
        <li>
          <a 
            href="/#values"
            className="text-gray-300 hover:text-white transition-colors"
            onClick={(e) => handleClick(e, '#values')}
          >
            Vision & Values
          </a>
        </li>
        <li>
          <a 
            href="/#how-it-works"
            className="text-gray-300 hover:text-white transition-colors"
            onClick={(e) => handleClick(e, '#how-it-works')}
          >
            How It Works
          </a>
        </li>
        <li>
          <a 
            href="/#register"
            className="text-gray-300 hover:text-white transition-colors"
            onClick={(e) => handleClick(e, '#register')}
          >
            Become a Pollster
          </a>
        </li>
      </ul>
    </div>
  );
};

export default FooterQuickLinks;
